import { render, staticRenderFns } from "./IFrame.vue?vue&type=template&id=29972546&scoped=true&"
import script from "./IFrame.vue?vue&type=script&lang=js&"
export * from "./IFrame.vue?vue&type=script&lang=js&"
import style0 from "./IFrame.vue?vue&type=style&index=0&id=29972546&prod&lang=css&"
import style1 from "./IFrame.vue?vue&type=style&index=1&id=29972546&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29972546",
  null
  
)

export default component.exports